<template>
    <v-container class="" fluid style="padding-top: 80px">
        <v-flex xs-12 class="row p-2 mr-2 ">
            <v-flex  xs12 lg6 class="pr-5 marginLeft">
            <v-img
                    height="200px"
                    :src="image"
                    style="border-radius: 5px; border: 1px solid #E9E9E9"
            ></v-img>
            <v-card-text class="px-0 pt-4 pl-2 font-weight-regular headline">{{name}}<!--{{moment().format('L')}} {{moment().format()}}-->
            </v-card-text>
            <v-card-text class="px-0 p-2 font-weight-regular subheading ">{{description}}</v-card-text>
            <v-card-text class="px-0 p-2  headline">
                <span v-if="butonDisable">
                    <div v-if="!userCourse">
                        <span v-if="carShop.length === 0">
                            <v-btn  color="#1A73E8" dark large @click="addCard(courseId)" v-if="!loader" >Inscribete al Curso</v-btn>
                            <v-btn  depressed disabled large v-else>Espere...</v-btn>
                        </span>

                        <v-btn  to="/payment" color="#1A73E8" dark large v-if="carShop.length > 0">Ir al carrito</v-btn>
                    </div>
                    <div v-else>
                        <v-btn color="#1A73E8" dark large :to="/course/ +this.id" v-if="!loader">Entrar al Curso</v-btn>
                    </div>
                </span>
            </v-card-text>
        </v-flex>
            <v-flex  xs12 lg6 v-if="!userCourse">
                <v-card-text class="marginLeft">
                    <course-item-tab-no-register></course-item-tab-no-register>
                </v-card-text>
            </v-flex>
            <v-flex  xs12 lg6 v-else>
               <progree-course></progree-course>
            </v-flex>
        </v-flex>
    </v-container>
</template>
<script>
    import axios from 'axios'
    import {mapState, mapGetters} from 'vuex'
    import {HalfCircleSpinner} from 'epic-spinners'
    import { SpringSpinner } from 'epic-spinners'
    import moment from 'moment';
    import toastr from 'toastr'

    import courseItemTabNoRegister from './courses_item_tab_no_register.vue'
    import progreeCourse from './progress_course.vue'

    export default {
        name: 'courseDescription',
        components: {
            courseItemTabNoRegister,
            HalfCircleSpinner,
            SpringSpinner,
            progreeCourse

        },
        data() {
            return {
                modules:'',
                name:'',
                description:'',
                price:'',
                id:'',
                userCourse:'',
                active:true,
                loader: false,
                butonDisable:false,


            }
        },
        created() {
            this.getCourses();
            this.getUserCourses();
        },
        computed: {
            ...mapGetters([
                'idCourse',
                'CourseName',
                'descriptionCourse',
                'carShop'
            ]),
            userId() {
                return JSON.parse(localStorage.getItem('user'));
            },
            courseId() {
                return JSON.parse(localStorage.getItem('courseId'));
            },

        },

        methods: {

            getShowModal:function () {
                this.dialog=true;
            },
            getCourses: function () {
                this.id          = localStorage.getItem('courseId');
                this.name        = localStorage.getItem('name');
                this.description = localStorage.getItem('description');
                this.price       = localStorage.getItem('price');
                this.image       = localStorage.getItem('image');

            },
            getUserCourses: function () {
                var url = '/api/v1/getUserInCourses';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('a_t');
                axios.post(url, {
                    headers: {
                        token
                    },
                    course_id: localStorage.getItem('courseId'),
                    user_id: this.userId.id,

                }).then(response => {
                    this.userCourse = response.data
                    this.butonDisable = true;
                })
            },
            addCard:function (id) {
                this.loader = true;

                this.$store.dispatch("shopingCart/addCart", id).then( data => {


                        this.loader = false;
                        console.log('data 2', data)

                })

            },

        },

    }
</script>
<style>
    .custom-loader {
        animation: loader 1s infinite;
        display: flex;
    }
    .v-progress-circular{
    margin: 1rem}
    @-moz-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-webkit-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @-o-keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .marginLeft{
        padding-left: 80px !important;
    }

    @media screen and (max-width: 1024px) {
        .marginLeft{
            padding-left: 30px !important;

        }
    }

</style>
